module.exports = __webpack_public_path__ + "img/header_en.db902043.png";